var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      attrs: {
        action: _setup.reverseFull({ name: "change_flavour" }),
        method: "post",
      },
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
        domProps: { value: _setup.context.csrf_token },
      }),
      _vm._v(" "),
      _c(_setup.CoreAdminLink, [
        _c("button", { attrs: { type: "submit" } }, [
          _vm._v("\n      " + _vm._s(_setup.text) + "\n    "),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }